export default __webpack_public_path__ + "static/media/pinwheel2.3dd8fe70.svg";